export default __webpack_public_path__ + "static/media/s2.21d82b01.jpeg";